<template>
  <div>
    <div class="activity-cell" v-for="(item, index) in list" :key="index">
      <div class="activity-cell-wrap">
        <a :href="'/activity/chinese/'+item.id" target="_blank" class="activity-cell-wrap-left" v-if="item.activity_img && item.activity_img.length > 0">
          <el-image :src="getSingleImagePath(item.activity_img)" lazy>
            <div slot="error" class="image-slot">
              <i class="el-icon-picture-outline"></i>
            </div>
            <div slot="placeholder" class="image-slot">
              <i class="el-icon-loading"></i>
            </div>
          </el-image>
        </a>
        <div class="activity-cell-wrap-right">
          <a :href="'/activity/chinese/'+item.id" target="_blank" class="activity-cell-wrap-right-link">
            {{ item.activity_name }}
          </a>
          <div class="activity-cell-wrap-right-box">
            <div class="activity-cell-wrap-right-box-cell">
              时间：{{ convertTime(item.activity_start_time, item.activity_end_time) }}
            </div>
            <div class="activity-cell-wrap-right-box-cell">
              地点：{{ item.activity_address || '腾讯会议' }}
            </div>
          </div>
          <template v-if="item.stop_reservation">
            <a :href="'/report/chinese/'+item.playback_file_id" target="_blank" class="activity-cell-wrap-right-btn btn-four" v-if="item.playback_status == '1' && item.playback_file_id">查看回放</a>
            <a :href="'/activity/chinese/'+item.id" target="_blank" class="activity-cell-wrap-right-btn btn-three" v-else-if="dateTimeToNowExpired(item.activity_end_time)">
              活动结束
            </a>
            <template v-else>
              <a :href="'/activity/chinese/'+item.id" target="_blank" class="activity-cell-wrap-right-btn btn-two" v-if="item.has_reservation && !item.is_examine && item.activity_reservations && item.activity_reservations.id">
                报名成功
              </a>
              <a :href="'/activity/chinese/'+item.id" target="_blank" class="activity-cell-wrap-right-btn btn-two" v-else-if="item.activity_reservations && item.activity_reservations.status==0">
                报名审核中
              </a>
              <a :href="'/activity/chinese/'+item.id" target="_blank" class="activity-cell-wrap-right-btn btn-two" v-else-if="item.activity_reservations && item.activity_reservations.status==1">
                报名成功
              </a>
              <a :href="'/activity/chinese/'+item.id" target="_blank" class="activity-cell-wrap-right-btn btn-two" v-else-if="item.activity_reservations && item.activity_reservations.status==2">
                报名失败
              </a>
              <a :href="'/activity/chinese/'+item.id" target="_blank" class="activity-cell-wrap-right-btn btn-three" v-else>
                活动结束
              </a>
            </template>
          </template>
          <template v-else>
            <a :href="'/report/chinese/'+item.playback_file_id" target="_blank" class="activity-cell-wrap-right-btn btn-four" v-if="item.playback_status == '1' && item.playback_file_id">查看回放</a>
            <a :href="'/activity/chinese/'+item.id" target="_blank" class="activity-cell-wrap-right-btn btn-three" v-else-if="dateTimeToNowExpired(item.activity_end_time)">
              活动结束
            </a>
            <template v-else>
              <a :href="'/activity/chinese/'+item.id" target="_blank" class="activity-cell-wrap-right-btn btn-two" v-if="item.has_reservation && !item.is_examine && item.activity_reservations && item.activity_reservations.id">
                报名成功
              </a>
              <template v-if="item.is_examine">
                <a :href="'/activity/chinese/'+item.id" target="_blank" class="activity-cell-wrap-right-btn btn-two" v-if="item.activity_reservations && item.activity_reservations.status==0">
                  报名审核中
                </a>
                <a :href="'/activity/chinese/'+item.id" target="_blank" class="activity-cell-wrap-right-btn btn-two" v-else-if="item.activity_reservations && item.activity_reservations.status==1">
                  报名成功
                </a>
                <a :href="'/activity/chinese/'+item.id" target="_blank" class="activity-cell-wrap-right-btn btn-two" v-else-if="item.activity_reservations && item.activity_reservations.status==2">
                  报名失败
                </a>
              </template>
              <a :href="'/activity/chinese/'+item.id" target="_blank" class="activity-cell-wrap-right-btn btn-one" v-if="!item.has_reservation && (!item.activity_reservations || !item.activity_reservations.id)">
                点击报名
              </a>
            </template>
          </template>
        </div>
      </div>
      <div class="activity-cell-footer">
        <span>{{ $moment(item.updated_at || item.created_at).format("YYYY-MM-DD") }}</span>
        <span class="space" v-if="item.activity_class && item.activity_class.class_name">|</span>
        <span>{{ item.activity_class && item.activity_class.class_name ? item.activity_class.class_name : '' }}</span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'ActivityCell',
  props: {
    list: {
      type: Array,
      default() {
        return []
      }
    },
  },
  methods: {
    getSingleImagePath(rows) {
      let str = "";
      if (rows && rows.length > 0) {
        str = rows[0]['img'];
      }
      return str;
    },
    convertTime(start_time, end_time) {
      let now_str = ""
      if (start_time && end_time) {
        const startMoment = this.$moment(start_time);
        const endMoment = this.$moment(end_time);
        const isSameDay = startMoment.isSame(endMoment, 'day');
        if (isSameDay) {
          now_str = `${startMoment.format('YYYY年MM月DD日 HH:mm')}～${endMoment.format('HH:mm')}`;
        } else {
          now_str = `${startMoment.format('YYYY年MM月DD日 HH:mm')}～${endMoment.format('YYYY年MM月DD日 HH:mm')}`;
        }
      }
      return now_str;
    },
    dateTimeToNowExpired(end_time) {
			const targetMoment = this.$moment(end_time);
			const now = this.$moment();
			const isExpired = targetMoment.isBefore(now);
			return isExpired;
    }
  }
}
</script>
<style lang="scss" scoped>
.activity-cell {
  padding: 24px 0;
  border-top: 1px solid #e9e9e9;
  font-family: HarmonyOS_Sans_Regular;
  &-wrap {
    display: flex;
    &-left {
      margin-right: 20px;
      line-height: 0;
      display: inline-block;
      .el-image {
        max-width: 213px;
        ::v-deep .image-slot {
          width: 213px;
          height: 140.44px;
          display: flex;
          justify-content: center;
          align-items: center;
          background-color: #f5f7fa;
          color: #909399;
        }
      }
    }
    &-right {
      &-link {
        color: #0B0B0B;
        font-size: 20px;
        font-family: HarmonyOS_Bold;
        text-decoration: none;
        display: inline-block;
      }
      &-box {
        margin-top: 20px;
        &-cell {
          font-size: 13px;
          &:nth-child(2n) {
            margin-top: 10px;
          }
        }
      }
      &-btn {
        margin-top: 20px;
        border-radius: 30px;
        padding: 10px 46px;
        text-decoration: none;
        display: inline-block;
        &:hover {
          opacity: 0.8;
        }
        &.btn-one {
          color: #fff;
          border: 1px solid #ff6517;
          background-color: #ff6517;
        }
        &.btn-two {
          color: #ff6517;
          border: 1px solid #ff6517;
        }
        &.btn-three {
          color: #ffffff;
          border: 1px solid #ada7a6;
          background-color: #ada7a6;
        }
        &.btn-four {
          color: #ffffff;
          border: 1px solid #ffb893;
          background-color: #ffb893;
        }
      }
    }
  }
  &-footer {
    margin-top: 35px;
    font-size: 12px;
    color: #747474;
    .space {
      margin: 0 15px;
    }
  }
}
/* 针对平板 */
@media screen and (min-width: 768px) and (max-width: 1024px) {}
/* 针对手机 */
@media screen and (max-width: 767px) {
  .activity-cell {
    &-wrap {
      flex-direction: column;
      &-left {
        margin-right: 0;
        margin-bottom: 20px;
        img {
          max-width: 100%;
        }
      }
    }
  }
}
</style>
